/* ══════════════════════════════════════════════════════════════════════════
   ALIA booking widget — r10 Whipped Feta port of the approved r08 build.
   Shadow-DOM isolated. Glowing green disc launcher + "Request a date" form.

   Corporate is the priority action and opens the lead form. The form itself
   follows the approved "Request a date" component design (night card, brass
   labels, jade action colour, field state on the .field wrapper).

   LEAD CAPTURE (shared-sheet contract):
   · The form POSTs one JSON object to the shared Google Apps Script web app
     (window.ALIA_WIDGET_CONFIG.endpoint, injected from layout/theme.liquid;
     the same URL is the built-in default so the asset is portable). All ALIA
     sites land in ONE spreadsheet.
   · Sheet columns: Received | Site | Page | Name | Company | Email | Phone |
     Event type | Event detail | Guests | Preferred date | Budget per head |
     Notes | Status. "Received" is stamped server-side; everything else is
     sent under BOTH its header name and a snake_case key, so the widget
     stays portable across sites whose receiving scripts differ.
   · "Page" is the FULL URL (window.location.href), matching r12 so the
     shared sheet keeps one convention in that column. pathname alone
     reports "/" for every homepage lead, which is most of them.
   · "Site" is the store NAME from window.ALIA_WIDGET_CONFIG.siteName
     (Liquid-injected, non-deferred), falling back to the hostname.
   · The POST is mode:'no-cors', so the response is opaque: the confirmation
     only means the request left the browser. The sheet is the only proof.

   FIELD DESIGN NOTES — do not "fix" these back:
   · The input well is LIGHTER than the card behind it; darker reads as a
     hole rather than a place to type.
   · Placeholder #BDB4A2 measures 5.9:1 on the well; the rim carries the
     control boundary at 3.2:1 on the card.
   · State lives on the .field WRAPPER, not on pseudo-classes on the input,
     so source order is priority order, and is-filled carries
     :not(.is-invalid) so a malformed value never wears the success rail.
   · Values are 16px — below that iOS zooms the page on focus.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  if (document.getElementById('alia-wgt-host')) return;

  /* ─── WIRING ─────────────────────────────────────────────────────────── */
  var SHARED_SHEET = 'https://script.google.com/macros/s/AKfycbymDImriMbjGLCHuvihZT-KhSDkHBb_sdlKqkOeaBY8bV-QbQivPefA2f79lKe5FOvFGw/exec';
  var PAGE_CFG = window.ALIA_WIDGET_CONFIG || {};
  var CONFIG = {
    phone: '(514) 566-2542',
    phoneHref: 'tel:+15145662542',
    opentable: 'https://www.opentable.ca/r/alia-montreal',
    siteName: PAGE_CFG.siteName || window.location.hostname,
    corporateEndpoint: PAGE_CFG.endpoint || SHARED_SHEET
  };

  /* ─── FONTS (for the launcher card; the form uses the system stack) ──── */
  if (!document.querySelector('link[href*="family=Chivo"]')) {
    var pc1 = document.createElement('link');
    pc1.rel = 'preconnect'; pc1.href = 'https://fonts.googleapis.com';
    var pc2 = document.createElement('link');
    pc2.rel = 'preconnect'; pc2.href = 'https://fonts.gstatic.com'; pc2.crossOrigin = '';
    var fl = document.createElement('link');
    fl.rel = 'stylesheet';
    fl.href = 'https://fonts.googleapis.com/css2?family=Chivo:wght@300;400;700&family=Chivo+Mono:wght@300;400;500&display=swap';
    document.head.appendChild(pc1); document.head.appendChild(pc2); document.head.appendChild(fl);
  }

  var CSS = `
  :host{
    /* ── theme tokens (index.liquid :root) — launcher + tracks ── */
    --w-char:var(--char,#241A11);
    --w-espresso:var(--espresso,#584737);
    --w-amber:var(--amber,#8A5F3A);
    --w-bone:var(--bone,#EEEDE3);
    --w-char-rgb:var(--char-rgb,36,26,17);
    --w-roast-rgb:var(--roast-rgb,74,51,31);
    --w-amber-rgb:var(--amber-rgb,138,95,58);
    --w-bone-rgb:var(--bone-rgb,238,237,227);
    --w-green:var(--cta-green,#1FA35B);
    --w-green-deep:var(--cta-green-d,#17824A);
    --w-green-bright:var(--cta-green-b,#27C06D);
    --w-ff:'Chivo',system-ui,sans-serif;
    --w-mono:'Chivo Mono',monospace;
    --w-ease-rise:var(--ease-rise,cubic-bezier(0.16,1,0.3,1));
    --w-ease-soft:var(--ease-soft,cubic-bezier(0.22,0.61,0.36,1));
    --w-edge:clamp(.9rem,2.5vw,1.6rem);

    /* ── enquiry-form tokens (approved "Request a date" component) ── */
    --night:#100E0A; --card:#17140F; --hair:#2A241A;
    --cream:#F3EEE1; --cream-dim:#A79E8C;
    --brass:#C9A45C; --brass-edge:#7A6437; --brass-lit:#9C8046;
    --well:#3D3428; --well-hover:#4A4031; --well-focus:#514534;
    --placeholder:#BDB4A2;
    --jade:#34A96B; --jade-lit:#46C983; --jade-ink:#04210F;
    --ember:#C4713F; --ember-lit:#E0705E;
    --sans:ui-sans-serif,-apple-system,BlinkMacSystemFont,"Helvetica Neue","Segoe UI",Roboto,Arial,sans-serif;
    --mono:ui-monospace,SFMono-Regular,"SF Mono",Menlo,"Cascadia Mono",Consolas,monospace;

    position:fixed; inset:0; z-index:9400; pointer-events:none;
    font-family:var(--w-ff); font-weight:300; line-height:1.5;
    -webkit-font-smoothing:antialiased;
  }
  *{margin:0;padding:0;box-sizing:border-box}
  [hidden]{display:none!important}
  button{font-family:inherit;color:inherit;background:none;border:none;cursor:pointer}
  :focus-visible{outline:2px solid var(--jade-lit);outline-offset:3px}

  /* ═══ SHELL ═══ */
  #rec{
    position:absolute;right:var(--w-edge);bottom:var(--w-edge);
    display:flex;align-items:flex-end;
    pointer-events:none;
    opacity:0;transform:translateY(14px);
    transition:opacity .5s var(--w-ease-soft),transform .5s var(--w-ease-soft);
  }
  #rec.revealed{opacity:1;transform:none}
  #rec > *{pointer-events:auto}

  /* ═══ THE LAUNCHER — glowing green circle with a "?" glyph ═══ */
  .disc{
    position:relative;flex:none;width:74px;height:74px;border-radius:50%;
    background:radial-gradient(circle at 38% 32%,var(--w-green-bright),var(--w-green) 62%,var(--w-green-deep));
    box-shadow:0 10px 28px rgba(var(--w-char-rgb),.5),
               0 0 0 1px rgba(39,192,109,.55),
               0 0 22px 4px rgba(39,192,109,.4),
               0 0 46px 12px rgba(39,192,109,.18);
    animation:discGlow 2.8s var(--w-ease-soft) infinite;
    transition:box-shadow .42s var(--w-ease-soft),transform .3s var(--w-ease-rise);
    z-index:2;
  }
  .disc::before{
    content:"?";
    position:absolute;inset:0;display:grid;place-items:center;
    font-family:var(--w-ff);font-weight:400;font-size:1.9rem;line-height:1;
    color:var(--w-char);
  }
  #rec.open .disc::before{content:"✕";font-size:1.35rem}
  .disc:hover{transform:translateY(-2px);
    box-shadow:0 12px 32px rgba(var(--w-char-rgb),.6),
               0 0 0 1px rgba(39,192,109,.8),
               0 0 30px 7px rgba(39,192,109,.55),
               0 0 60px 16px rgba(39,192,109,.26)}
  #rec.open .disc{animation:none;
    box-shadow:0 10px 28px rgba(var(--w-char-rgb),.55),
               0 0 0 1px rgba(39,192,109,.7),
               0 0 18px 3px rgba(39,192,109,.35)}
  @keyframes discGlow{
    0%,100%{box-shadow:0 10px 28px rgba(var(--w-char-rgb),.5),
                       0 0 0 1px rgba(39,192,109,.55),
                       0 0 22px 4px rgba(39,192,109,.4),
                       0 0 46px 12px rgba(39,192,109,.18)}
    50%{box-shadow:0 10px 28px rgba(var(--w-char-rgb),.5),
                   0 0 0 1px rgba(39,192,109,.75),
                   0 0 30px 7px rgba(39,192,109,.6),
                   0 0 60px 16px rgba(39,192,109,.3)}
  }
  .disc-cue{
    position:absolute;right:0;bottom:calc(100% + .55rem);
    font-family:var(--w-mono);font-size:.54rem;font-weight:400;
    letter-spacing:.34em;text-transform:uppercase;color:var(--w-amber);
    white-space:nowrap;pointer-events:none;
    opacity:0;transform:translateY(4px);
    transition:opacity .38s var(--w-ease-soft),transform .38s var(--w-ease-soft);
  }
  .disc:hover + .disc-cue{opacity:1;transform:none}
  #rec.open .disc-cue{opacity:0}

  /* ═══ THE CARD — grows out from behind the disc ═══ */
  .card{
    position:relative;overflow:hidden;
    max-width:0;opacity:0;
    background:var(--w-espresso);
    border:1px solid rgba(var(--w-bone-rgb),.22);
    border-right:0;
    box-shadow:0 18px 44px rgba(var(--w-char-rgb),.62);
    transform:translateX(22px);
    transition:max-width .58s var(--w-ease-rise),
               opacity .34s var(--w-ease-soft),
               transform .58s var(--w-ease-rise);
    margin-right:-37px;
    padding-right:44px;
  }
  #rec.open .card{max-width:320px;opacity:1;transform:none}
  .card-in{width:276px;padding:1.05rem 0 1.05rem 1.15rem}
  .card::before,.card::after{content:"";position:absolute;width:16px;height:16px;pointer-events:none}
  .card::before{left:-1px;top:-1px;
    border-left:1px solid rgba(var(--w-amber-rgb),.6);border-top:1px solid rgba(var(--w-amber-rgb),.6)}
  .card::after{left:-1px;bottom:-1px;
    border-left:1px solid rgba(var(--w-amber-rgb),.6);border-bottom:1px solid rgba(var(--w-amber-rgb),.6)}
  .card-eye{
    display:flex;align-items:center;gap:.7rem;
    font-family:var(--w-mono);font-weight:400;font-size:.56rem;
    letter-spacing:.34em;text-transform:uppercase;color:var(--w-amber);
    margin-bottom:.85rem;
  }
  .card-eye::before{content:"";width:26px;height:1px;background:var(--w-amber);flex:none}
  .track{
    display:flex;align-items:center;gap:.7rem;width:100%;text-align:left;
    padding:.62rem .8rem .62rem 0;
    border-top:1px solid rgba(var(--w-bone-rgb),.14);
    color:rgba(var(--w-bone-rgb),.82);
    position:relative;z-index:0;
    transition:color .38s var(--w-ease-soft),padding-left .38s var(--w-ease-rise);
  }
  .track:first-of-type{border-top:0}
  .track::before{
    content:"";position:absolute;inset:0 0 0 -1.15rem;
    background:rgba(var(--w-amber-rgb),.14);
    transform:translateY(101%);transition:transform .42s var(--w-ease-rise);z-index:-1;
  }
  .track:hover{color:var(--w-bone);padding-left:.35rem}
  .track:hover::before{transform:translateY(0)}
  .tn{font-family:var(--w-mono);font-size:.58rem;font-weight:400;letter-spacing:.14em;
      color:rgba(var(--w-bone-rgb),.45);flex:none}
  .tt{font-size:.82rem;font-weight:300;text-transform:uppercase;letter-spacing:.06em;line-height:1.1}
  .tg{margin-left:auto;font-family:var(--w-mono);font-size:.5rem;font-weight:400;
      letter-spacing:.2em;text-transform:uppercase;color:rgba(var(--w-bone-rgb),.42);flex:none}
  .track.corp .tt{color:var(--w-bone)}
  .track.corp .tg{color:var(--w-green-bright)}
  .track.corp .tn{color:var(--w-amber)}
  .card-foot{
    margin-top:.85rem;padding-top:.7rem;border-top:1px solid rgba(var(--w-bone-rgb),.14);
    font-family:var(--w-mono);font-size:.54rem;letter-spacing:.2em;text-transform:uppercase;
    color:rgba(var(--w-bone-rgb),.4);
  }

  /* ═══ SCRIM + MODAL SHELL ═══ */
  .scrim{
    position:fixed;inset:0;background:rgba(16,14,10,.84);
    backdrop-filter:blur(6px) saturate(1.1);-webkit-backdrop-filter:blur(6px) saturate(1.1);
    display:none;align-items:center;justify-content:center;padding:.8rem;
    overflow:hidden; /* the scrim never scrolls — the modal shrinks instead */
    pointer-events:auto;z-index:10;
  }
  .scrim.on{display:flex}
  .modal{
    position:relative;width:min(660px,100%);
    max-height:calc(100vh - 1.6rem);
    max-height:calc(100dvh - 1.6rem);
    overflow-y:auto;
    background:var(--card);color:var(--cream);
    font-family:var(--sans);font-size:16px;line-height:1.6;
    border:1px solid var(--hair);border-top:2px solid var(--jade);
    border-radius:5px;
    animation:rise .42s var(--w-ease-rise);
    color-scheme:dark; /* light date-picker glyph on the dark well */
  }
  @keyframes rise{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:none}}
  .modal ::selection{background:var(--jade);color:var(--jade-ink)}
  .m-close{
    position:absolute;top:14px;right:14px;width:34px;height:34px;
    display:grid;place-items:center;font-size:1rem;line-height:1;
    color:var(--cream-dim);border:1px solid var(--hair);border-radius:4px;
    transition:color .2s,border-color .2s,transform .3s var(--w-ease-rise);
    z-index:2;
  }
  .m-close:hover{color:var(--cream);border-color:var(--brass-edge);transform:rotate(90deg)}

  /* ═══ HEAD ═══ */
  .ae-head{padding:26px 28px 20px;border-bottom:1px solid var(--hair)}
  .ae-eyebrow{
    font-family:var(--mono);font-size:11px;letter-spacing:.28em;
    text-transform:uppercase;color:var(--brass);margin:0;
  }
  .ae-title{font-size:1.6rem;font-weight:300;letter-spacing:-.02em;margin:6px 0 6px;line-height:1.15;color:var(--cream)}
  .ae-sub{margin:0;font-size:14px;color:var(--cream-dim);max-width:46ch}
  .ae-body{padding:24px 28px 28px}

  /* ═══ FIELD GRID ═══ */
  .ae-grid{display:grid;grid-template-columns:1fr 1fr;gap:15px}
  .ae-span2{grid-column:1 / -1}
  @media(max-width:620px){.ae-grid{grid-template-columns:1fr}}

  .field{display:flex;flex-direction:column;gap:7px;min-width:0;position:relative}
  .field > label{
    font-family:var(--mono);font-size:10.5px;letter-spacing:.2em;
    text-transform:uppercase;color:var(--brass);
  }
  .field .opt{color:var(--brass-edge)}

  /* the well: REST — lighter than the card, brass rim, lit top edge */
  .field input,
  .field select,
  .field textarea{
    font-family:var(--sans);
    font-size:16px;
    color:var(--cream);
    background:var(--well);
    border:0;
    border-radius:4px;
    padding:13px 14px;
    width:100%;
    box-shadow:inset 0 0 0 1px var(--brass-edge),
               inset 0 1px 0 var(--brass-lit),
               0 1px 0 rgba(0,0,0,.5),
               0 4px 12px -6px rgba(0,0,0,.7);
    transition:background .16s ease, box-shadow .16s ease;
  }
  .field textarea{resize:vertical;min-height:88px;font-size:15px;line-height:1.55}
  .field input::placeholder,
  .field textarea::placeholder{color:var(--placeholder);opacity:1}

  .field input:hover,
  .field select:hover,
  .field textarea:hover{
    background:var(--well-hover);
    box-shadow:inset 0 0 0 1px var(--brass-lit), inset 0 1px 0 #B08F4E,
               0 1px 0 rgba(0,0,0,.5), 0 4px 12px -6px rgba(0,0,0,.7);
  }
  .field input:focus,
  .field select:focus,
  .field textarea:focus{
    outline:none;
    background:var(--well-focus);
    box-shadow:inset 0 0 0 2px var(--jade-lit), 0 0 0 4px rgba(52,169,107,.16);
  }

  /* FILLED — jade rail; stands down for the error state */
  .field.is-filled:not(.is-invalid) input,
  .field.is-filled:not(.is-invalid) select,
  .field.is-filled:not(.is-invalid) textarea{
    box-shadow:inset 4px 0 0 var(--jade), inset 0 0 0 1px var(--brass-edge),
               inset 0 1px 0 var(--brass-lit), 0 1px 0 rgba(0,0,0,.5);
  }
  .field.is-filled:not(.is-invalid) input:focus,
  .field.is-filled:not(.is-invalid) select:focus,
  .field.is-filled:not(.is-invalid) textarea:focus{
    box-shadow:inset 4px 0 0 var(--jade), inset 0 0 0 2px var(--jade-lit),
               0 0 0 4px rgba(52,169,107,.16);
  }

  /* INVALID — full rim + label-row flag, findable across the form */
  .field.is-invalid input,
  .field.is-invalid select,
  .field.is-invalid textarea{
    box-shadow:inset 4px 0 0 var(--ember), inset 0 0 0 1px #B4523C, 0 1px 0 rgba(0,0,0,.5);
  }
  .field.is-invalid input:focus,
  .field.is-invalid select:focus,
  .field.is-invalid textarea:focus{
    box-shadow:inset 4px 0 0 var(--ember), inset 0 0 0 2px var(--ember),
               0 0 0 4px rgba(196,113,63,.18);
  }
  .err{
    display:none;position:absolute;top:0;right:0;
    font-family:var(--mono);font-size:10.5px;letter-spacing:.1em;
    color:var(--ember-lit);text-transform:uppercase;
  }
  .field.is-invalid .err{display:block}

  /* native control quirks */
  .field:not(.is-filled) input[type="date"]{color:var(--placeholder)}
  .field input[type="number"]{-moz-appearance:textfield;appearance:textfield}
  .field input[type="number"]::-webkit-outer-spin-button,
  .field input[type="number"]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}
  .field select{appearance:none;-webkit-appearance:none;cursor:pointer;padding-right:34px}
  .select-wrap{position:relative}
  .select-wrap::after{
    content:"▾";position:absolute;right:13px;bottom:12px;
    color:var(--brass);pointer-events:none;font-size:12px;
  }
  .field input:-webkit-autofill{
    -webkit-text-fill-color:var(--cream);
    transition:background-color 8000s ease-in-out 0s;
    -webkit-box-shadow:inset 0 0 0 1px var(--brass-edge),
                       inset 0 1px 0 var(--brass-lit),
                       inset 0 0 0 100px var(--well);
  }

  /* ═══ FOOT + BUTTONS ═══ */
  .ae-foot{
    display:flex;align-items:center;justify-content:space-between;gap:16px;
    flex-wrap:wrap;margin-top:22px;padding-top:20px;border-top:1px solid var(--hair);
  }
  .ae-foot p{margin:0;font-size:12.5px;color:var(--cream-dim);max-width:34ch}
  .btn{
    font-family:var(--mono);font-size:11.5px;letter-spacing:.16em;
    text-transform:uppercase;text-decoration:none;white-space:nowrap;
    border-radius:4px;padding:12px 18px;cursor:pointer;
    display:inline-flex;align-items:center;gap:8px;
    border:1px solid var(--jade);background:var(--jade);color:var(--jade-ink);font-weight:700;
    transition:background .16s ease, box-shadow .2s ease, transform .16s ease;
  }
  .btn:hover{background:var(--jade-lit);box-shadow:0 6px 26px -8px rgba(52,169,107,.8)}
  .btn:active{transform:translateY(1px)}
  .btn[disabled]{opacity:.6;cursor:progress}
  .btn-ghost{background:transparent;color:var(--jade-lit);border-color:#1D5F3D;font-weight:400}
  .btn-ghost:hover{background:rgba(52,169,107,.1);border-color:var(--jade);box-shadow:none}
  .m-note{
    margin:10px 0 0;font-family:var(--mono);font-size:11px;letter-spacing:.08em;
    text-transform:uppercase;color:var(--ember-lit);min-height:1em;
  }

  /* ═══ CONFIRMATION — sized to land in ONE view, no modal scroll.
     The summary runs two-up with the label stacked over the value, which
     halves its height; long values clamp to two lines. ═══ */
  .done{display:flex;flex-direction:column;gap:12px;padding:2px 0 0}
  .done-mark{
    width:38px;height:38px;border-radius:50%;background:var(--jade);
    color:var(--jade-ink);display:grid;place-items:center;font-size:18px;font-weight:700;
  }
  .done-h{font-size:1.45rem;font-weight:300;letter-spacing:-.02em;margin:0 0 6px;line-height:1.1;color:var(--cream)}
  .done-lede{margin:0;color:var(--cream-dim);font-size:13.5px;max-width:56ch}
  .done-lede b{color:var(--cream);font-weight:600}
  .summary{
    display:grid;grid-template-columns:1fr 1fr;gap:1px;background:var(--hair);
    border:1px solid var(--hair);border-radius:3px;overflow:hidden;margin:0;
  }
  .summary > div{
    background:var(--night);padding:8px 12px;display:flex;
    flex-direction:column;gap:2px;font-size:13px;min-width:0;
  }
  .summary > div[data-wide]{grid-column:1/-1}
  .summary > div:last-child:nth-child(odd){grid-column:1/-1}
  .summary dt{
    font-family:var(--mono);font-size:10px;letter-spacing:.18em;
    text-transform:uppercase;color:var(--brass);
  }
  .summary dd{
    margin:0;color:var(--cream);overflow-wrap:anywhere;
    display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;
  }
  .done-next{border-top:1px solid var(--hair);padding-top:12px;display:flex;flex-direction:column;gap:8px}
  .done-actions{display:flex;gap:10px;flex-wrap:wrap}
  /* confirmation shrinks in the same order as the form: spacing first,
     then text scale, then supporting pieces. The summary data and the two
     action buttons never go. */
  @media(max-height:860px){
    .done{gap:10px}
    .done-mark{width:32px;height:32px;font-size:15px}
    .summary > div{padding:7px 11px}
  }
  @media(max-height:780px){
    .done{gap:8px}
    .done-h{font-size:1.25rem;margin:0 0 4px}
    .done-lede{font-size:12.5px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
    .summary > div{padding:6px 10px;font-size:12.5px}
    .summary dd{-webkit-line-clamp:1}
    .done-next{padding-top:8px;gap:6px}
    .done-actions .btn{padding:9px 14px}
  }
  @media(max-height:700px){
    .done-next .ae-eyebrow{display:none}
  }
  @media(max-height:640px){
    .done-mark{display:none}
  }

  /* the modal shrinks to fit short viewports rather than scrolling:
     padding first, then the textarea, then supporting copy.
     Fields and the submit button never go. */
  @media(max-height:860px){
    .ae-head{padding:16px 20px 12px}
    .ae-body{padding:14px 20px 18px}
    .ae-grid{gap:10px}
    .field{gap:5px}
    .field textarea{min-height:56px}
    .ae-foot{margin-top:14px;padding-top:12px}
  }
  @media(max-height:780px){
    .ae-head{padding:12px 20px 10px}
    .ae-title{font-size:1.35rem;margin:4px 0 2px}
    .ae-sub{display:none}
    .ae-grid{gap:8px}
    .field{gap:4px}
    .field > label{font-size:10px}
    .field input,.field select{padding:8px 12px}
    .field textarea{min-height:44px;padding:8px 12px}
  }
  @media(max-height:700px){
    .ae-head{padding:10px 18px 8px}
    .ae-body{padding:10px 18px 14px}
    .ae-foot{margin-top:10px;padding-top:8px}
    .ae-foot p{display:none}
    .btn{padding:10px 16px}
    .field textarea{min-height:38px}
    .m-note{margin-top:6px}
  }
  @media(max-width:620px){
    .ae-head{padding:18px 20px 15px}
    .ae-body{padding:18px 20px 22px}
    .ae-title{font-size:1.35rem}
  }

  /* ═══ TOAST ═══ */
  .toast{
    position:fixed;left:50%;bottom:calc(var(--w-edge) + 100px);
    transform:translateX(-50%) translateY(16px);
    background:var(--w-espresso);border:1px solid rgba(var(--w-bone-rgb),.22);border-radius:0;
    padding:.85rem 1.3rem;color:var(--w-bone);
    font-family:var(--w-mono);font-size:.66rem;letter-spacing:.14em;text-transform:uppercase;
    opacity:0;pointer-events:none;
    transition:opacity .3s var(--w-ease-soft),transform .3s var(--w-ease-soft);z-index:12;
  }
  .toast.on{opacity:1;transform:translateX(-50%) translateY(0)}
  .toast b{color:var(--w-amber);font-weight:400}

  /* ═══ SMALL SCREENS — the card stacks above the disc ═══ */
  @media(max-width:620px){
    #rec{flex-direction:column;align-items:flex-end;left:var(--w-edge)}
    .card{
      border-right:1px solid rgba(var(--w-bone-rgb),.22);
      margin-right:0;padding-right:0;
      margin-bottom:-30px;padding-bottom:38px;
      max-width:none;width:100%;
      max-height:0;transform:translateY(18px);
      transition:max-height .58s var(--w-ease-rise),
                 opacity .34s var(--w-ease-soft),
                 transform .58s var(--w-ease-rise);
    }
    #rec.open .card{max-width:none;max-height:340px;transform:none}
    .card-in{width:auto;padding:1.05rem 1.15rem}
    .track::before{inset:0 -1.15rem}
    .toast{bottom:calc(var(--w-edge) + 92px);width:calc(100vw - 2.4rem);text-align:center}
  }

  @media(prefers-reduced-motion:reduce){
    *{animation:none!important;transition-duration:.01ms!important}
  }
  `;

  var HTML = `
  <div id="rec">
    <div class="card">
      <div class="card-in">
        <p class="card-eye">Reservez &middot; ALIA</p>
        <button class="track corp" type="button" data-act="corp">
          <span class="tn">01</span><span class="tt">Corporate events</span><span class="tg">Priority</span>
        </button>
        <button class="track" type="button" data-act="rest">
          <span class="tn">02</span><span class="tt">Restaurant</span><span class="tg">Book</span>
        </button>
        <button class="track" type="button" data-act="club">
          <span class="tn">03</span><span class="tt">The Club</span><span class="tg">Call</span>
        </button>
        <p class="card-foot">997 Rue Saint-Jacques &middot; Montreal</p>
      </div>
    </div>
    <button class="disc" type="button" data-toggle aria-expanded="false" aria-label="Reservez — open booking"></button>
    <span class="disc-cue" aria-hidden="true">Reservez</span>
  </div>

  <div class="scrim" data-scrim>
    <div class="modal" role="dialog" aria-modal="true" aria-labelledby="aw-title">
      <button class="m-close" type="button" data-mclose aria-label="Close">&#10005;</button>

      <div class="ae-head">
        <p class="ae-eyebrow">Private events</p>
        <h3 class="ae-title" id="aw-title" data-head-title>Request a date</h3>
        <p class="ae-sub" data-head-sub>We answer the same day, with availability and a starting menu.</p>
      </div>

      <div class="ae-body">
        <form data-form novalidate>
          <div class="ae-grid">

            <div class="field">
              <label for="aw-name">Your name</label>
              <input id="aw-name" name="Name" type="text" autocomplete="name" placeholder="Alex Tremblay" required>
              <span class="err">Required</span>
            </div>

            <div class="field">
              <label for="aw-co">Company</label>
              <input id="aw-co" name="Company" type="text" autocomplete="organization" placeholder="Northbound Capital" required>
              <span class="err">Required</span>
            </div>

            <div class="field">
              <label for="aw-email">Work email</label>
              <input id="aw-email" name="Email" type="email" autocomplete="email" placeholder="alex@northbound.ca" required>
              <span class="err">Enter a valid email</span>
            </div>

            <div class="field">
              <label for="aw-phone">Phone</label>
              <input id="aw-phone" name="Phone" type="tel" autocomplete="tel" placeholder="514 555 0142" required>
              <span class="err">Required</span>
            </div>

            <div class="field">
              <label for="aw-type">Event</label>
              <div class="select-wrap">
                <select id="aw-type" name="Event" required>
                  <option value="" selected>Choose one</option>
                  <option>Year-end party</option>
                  <option>Client dinner</option>
                  <option>Full buyout</option>
                  <option>Cocktail reception</option>
                  <option>Product launch</option>
                  <option>Something else</option>
                </select>
              </div>
              <span class="err">Required</span>
            </div>

            <div class="field">
              <label for="aw-guests">Guests</label>
              <input id="aw-guests" name="Guests" type="number" min="1" max="400" inputmode="numeric" placeholder="60" required>
              <span class="err">Required</span>
            </div>

            <div class="field ae-span2" data-detail-wrap hidden>
              <label for="aw-detail">Event detail</label>
              <input id="aw-detail" name="EventDetail" type="text" placeholder="Tell us what you are planning">
            </div>

            <div class="field">
              <label for="aw-date">Preferred date</label>
              <input id="aw-date" name="Date" type="date" required>
              <span class="err">Required</span>
            </div>

            <div class="field">
              <label for="aw-budget">Budget per head <span class="opt">(optional)</span></label>
              <div class="select-wrap">
                <select id="aw-budget" name="Budget">
                  <option value="" selected>Not sure yet</option>
                  <option>$95 to $150</option>
                  <option>$150 to $225</option>
                  <option>$225 and up</option>
                </select>
              </div>
            </div>

            <div class="field ae-span2">
              <label for="aw-notes">Anything we should know <span class="opt">(optional)</span></label>
              <textarea id="aw-notes" name="Notes" placeholder="Dietary needs, AV, a speech, a hard end time."></textarea>
            </div>

          </div>

          <div class="ae-foot">
            <p>We hold provisional dates for 48 hours, no deposit.</p>
            <button class="btn" type="submit" data-msubmit>Send request</button>
          </div>
          <p class="m-note" data-mnote></p>
        </form>

        <div class="done" data-cview hidden aria-live="polite">
          <div class="done-mark" aria-hidden="true">&#10003;</div>
          <div>
            <h3 class="done-h" data-c-name>Thank you.</h3>
            <p class="done-lede" data-c-lede></p>
          </div>
          <dl class="summary" data-c-grid></dl>
          <div class="done-next">
            <p class="ae-eyebrow">If you need us sooner</p>
            <div class="done-actions">
              <a class="btn btn-ghost" href="tel:+15145662542">Call (514) 566-2542</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="toast" data-toast role="status" aria-live="polite"></div>
  `;

  /* ─── MOUNT ──────────────────────────────────────────────────────────── */
  var host = document.createElement('div');
  host.id = 'alia-wgt-host';
  document.body.appendChild(host);
  var root = host.attachShadow({ mode: 'open' });
  root.innerHTML = '<style>' + CSS + '</style>' + HTML;

  // The theme's own dock occupies this corner — the widget replaces it.
  var hide = document.createElement('style');
  hide.textContent = '.alia-cta-dock{display:none!important}';
  document.head.appendChild(hide);

  var rec    = root.getElementById('rec');
  var toggle = root.querySelector('[data-toggle]');
  var scrim  = root.querySelector('[data-scrim]');
  var form   = root.querySelector('[data-form]');
  var cview  = root.querySelector('[data-cview]');
  var note   = root.querySelector('[data-mnote]');
  var submit = root.querySelector('[data-msubmit]');
  var toast  = root.querySelector('[data-toast]');
  var headTitle  = root.querySelector('[data-head-title]');
  var headSub    = root.querySelector('[data-head-sub]');
  var typeSel    = root.getElementById('aw-type');
  var detailWrap = root.querySelector('[data-detail-wrap]');
  var dateInput  = root.getElementById('aw-date');
  var tTimer;

  var HEAD_TITLE_REST = 'Request a date';
  var HEAD_SUB_REST   = 'We answer the same day, with availability and a starting menu.';

  function showToast(html) {
    toast.innerHTML = html; // static strings only — user input never lands here
    toast.classList.add('on');
    clearTimeout(tTimer);
    tTimer = setTimeout(function () { toast.classList.remove('on'); }, 3200);
  }

  function setOpen(on) {
    rec.classList.toggle('open', on);
    toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
    toggle.setAttribute('aria-label', on ? 'Close booking' : 'Reservez — open booking');
  }
  toggle.addEventListener('click', function () { setOpen(!rec.classList.contains('open')); });

  /* page scroll lock — compensate for the vanished scrollbar so the page
     does not jump sideways, and pause Lenis where the theme runs it */
  var lockedPad = '';
  function lockPage(on) {
    var b = document.body, h = document.documentElement;
    if (on) {
      var sbw = window.innerWidth - h.clientWidth;
      lockedPad = b.style.paddingRight || '';
      if (sbw > 0) b.style.paddingRight = sbw + 'px';
      b.style.overflow = 'hidden';
      /* the viewport scrollbar belongs to the root element — locking body
         alone leaves the page's bar visible beside the modal's */
      h.style.overflow = 'hidden';
      if (window.__lenis && window.__lenis.stop) { try { window.__lenis.stop(); } catch (e) {} }
    } else {
      b.style.overflow = '';
      h.style.overflow = '';
      b.style.paddingRight = lockedPad;
      if (window.__lenis && window.__lenis.start) { try { window.__lenis.start(); } catch (e) {} }
    }
  }

  /* ── field state on the .field wrapper ─────────────────────────────── */
  var fields = [].slice.call(form.querySelectorAll('.field'));
  function control(f) { return f.querySelector('input, select, textarea'); }
  function syncField(f) {
    var c = control(f);
    if (!c) return;
    f.classList.toggle('is-filled', String(c.value || '').trim() !== '');
    if (f.dataset.touched === '1') {
      var bad = !c.checkValidity();
      f.classList.toggle('is-invalid', bad);
      c.setAttribute('aria-invalid', String(bad));
    }
  }
  function syncAll() { fields.forEach(syncField); }
  fields.forEach(function (f) {
    var c = control(f);
    if (!c) return;
    c.addEventListener('input',  function () { syncField(f); });
    c.addEventListener('change', function () { syncField(f); });
    c.addEventListener('blur',   function () { f.dataset.touched = '1'; syncField(f); });
  });
  syncAll();

  /* a date in the past helps nobody */
  dateInput.min = new Date().toISOString().slice(0, 10);

  /* conditional Event detail — only when Event = "Something else".
     required toggles with visibility so a hidden field can never block
     checkValidity() with nothing on screen to explain why */
  typeSel.addEventListener('change', function () {
    var on = typeSel.value === 'Something else';
    detailWrap.hidden = !on;
    if (!on) {
      root.getElementById('aw-detail').value = '';
      detailWrap.classList.remove('is-filled', 'is-invalid');
    }
  });

  function resetForm() {
    form.reset();
    /* reset() clears values but not the wrapper state */
    fields.forEach(function (f) {
      f.classList.remove('is-filled', 'is-invalid');
      delete f.dataset.touched;
      var c = control(f);
      if (c) c.removeAttribute('aria-invalid');
    });
    detailWrap.hidden = true;
    note.textContent = '';
  }

  function openModal() {
    headTitle.textContent = HEAD_TITLE_REST;
    headSub.textContent = HEAD_SUB_REST;
    form.hidden = false;
    cview.hidden = true;
    scrim.classList.add('on');
    lockPage(true);
    note.textContent = '';
    setTimeout(function () { var f = root.getElementById('aw-name'); if (f) f.focus(); }, 60);
  }
  function closeModal() { scrim.classList.remove('on'); lockPage(false); }
  root.querySelector('[data-mclose]').addEventListener('click', closeModal);
  scrim.addEventListener('click', function (e) { if (e.target === scrim) closeModal(); });

  /* Corporate = priority → lead form. Club → phone. Dining room → OpenTable. */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var a = b.getAttribute('data-act');
    if (a === 'corp') {
      openModal();
    } else if (a === 'club') {
      showToast('<b>The Club</b> &middot; ' + CONFIG.phone);
      window.location.href = CONFIG.phoneHref;
    } else if (a === 'rest') {
      showToast('<b>Restaurant</b> &middot; OpenTable');
      window.open(CONFIG.opentable, '_blank', 'noopener');
    }
  });

  /* page-side CTAs: any [data-alia-corp] opens the form; its tel: href
     stays as the no-JS fallback */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-alia-corp]');
    if (!t) return;
    e.preventDefault();
    openModal();
  });
  window.ALIA_WIDGET = { openCorporate: openModal };

  /* 'YYYY-MM-DD' through new Date() parses as UTC and shows the previous
     day west of Greenwich — split the ISO string and construct locally */
  function prettyDate(iso) {
    if (!iso) return '';
    var p = iso.split('-');
    if (p.length !== 3) return iso;
    var dt = new Date(+p[0], +p[1] - 1, +p[2]);
    return dt.toLocaleDateString('en-CA', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }

  /* confirmation replaces the form in place — everything a stranger typed
     goes through textContent / createTextNode, never innerHTML */
  function showConfirm(v) {
    var first = (v.name || '').split(/\s+/)[0];
    var pretty = prettyDate(v.date);

    headTitle.textContent = 'Request received';
    headSub.textContent = 'One of the events team is already on it.';
    root.querySelector('[data-c-name]').textContent = first ? 'Thank you, ' + first + '.' : 'Thank you.';

    var lede = root.querySelector('[data-c-lede]');
    lede.textContent = '';
    lede.appendChild(document.createTextNode('Your request for '));
    var b1 = document.createElement('b'); b1.textContent = v.guests + ' guests'; lede.appendChild(b1);
    lede.appendChild(document.createTextNode(' on '));
    var b2 = document.createElement('b'); b2.textContent = pretty; lede.appendChild(b2);
    lede.appendChild(document.createTextNode(' is with the events team. We hold the date provisionally while we come back to you.'));

    var grid = root.querySelector('[data-c-grid]');
    grid.innerHTML = '';
    [
      ['Name', v.name],
      ['Company', v.company],
      ['Email', v.email],
      ['Phone', v.phone],
      ['Event', v.eventType + (v.eventDetail ? ' — ' + v.eventDetail : '')],
      ['Guests', v.guests],
      ['Date', pretty],
      ['Budget per head', v.budget],
      ['Notes', v.notes]
    ].forEach(function (r) {
      if (!r[1]) return;
      var row = document.createElement('div');
      if (r[0] === 'Notes' || r[0] === 'Event') row.setAttribute('data-wide', '');
      var dt = document.createElement('dt'); dt.textContent = r[0];
      var dd = document.createElement('dd'); dd.textContent = r[1];
      row.appendChild(dt); row.appendChild(dd);
      grid.appendChild(row);
    });

    form.hidden = true;
    cview.hidden = false;
    root.querySelector('.modal').scrollTop = 0;
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    fields.forEach(function (f) { f.dataset.touched = '1'; });
    syncAll();
    if (!form.checkValidity()) {
      var bad = form.querySelector('.field.is-invalid input, .field.is-invalid select, .field.is-invalid textarea');
      if (bad) bad.focus({ preventScroll: true });
      return;
    }

    var v = {
      name:        root.getElementById('aw-name').value.trim(),
      company:     root.getElementById('aw-co').value.trim(),
      email:       root.getElementById('aw-email').value.trim(),
      phone:       root.getElementById('aw-phone').value.trim(),
      eventType:   typeSel.value,
      eventDetail: root.getElementById('aw-detail').value.trim(),
      guests:      root.getElementById('aw-guests').value,
      date:        dateInput.value,
      budget:      root.getElementById('aw-budget').value,
      notes:       root.getElementById('aw-notes').value.trim()
    };

    /* Shared-sheet contract: the receiving script maps by sheet-header text,
       so every value goes out under BOTH its header name and a snake key.
       "Received" is stamped by the sheet itself. */
    var payload = {};
    [
      ['Name',           'name',         v.name],
      ['Company',        'company',      v.company],
      ['Email',          'email',        v.email],
      ['Phone',          'phone',        v.phone],
      ['Event type',     'event_type',   v.eventType],
      ['Event detail',   'event_detail', v.eventDetail],
      ['Guests',         'guests',       v.guests],
      ['Preferred date', 'date',         v.date],
      ['Budget per head','budget',       v.budget],
      ['Notes',          'notes',        v.notes],
      ['Site',           'site',         CONFIG.siteName],
      ['Page',           'page',         window.location.href],
      ['Status',         'status',       'New']
    ].forEach(function (p) { payload[p[0]] = p[2]; payload[p[1]] = p[2]; });

    if (!CONFIG.corporateEndpoint) {
      showConfirm(v);
      resetForm();
      return;
    }

    submit.disabled = true;
    submit.textContent = 'Sending';
    note.textContent = '';
    // text/plain keeps this a simple request, so no CORS preflight to configure
    // on the Apps Script side; the script reads e.postData.contents.
    // no-cors → the response is opaque: only a total network failure is caught.
    fetch(CONFIG.corporateEndpoint, {
      method: 'POST',
      mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    }).then(function () {
      showConfirm(v);
      resetForm();
    })['catch'](function () {
      note.textContent = 'Could not send — please call ' + CONFIG.phone;
    }).then(function () {
      submit.disabled = false;
      submit.textContent = 'Send request';
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (scrim.classList.contains('on')) closeModal();
    else if (rec.classList.contains('open')) setOpen(false);
  });

  /* ─── REVEAL — only once the theme's preloader has cleared ────────────── */
  (function () {
    function reveal() { rec.classList.add('revealed'); }
    /* r10 note: this theme's .tex-veil is a PERMANENT decorative layer — a
       selector list that matches it would defer the reveal to the 6s timeout
       on every load. Watch the preloader only. */
    var SEL = '#preloader,[id*="preload" i],[class*="preloader" i]';
    function run() {
      if (document.querySelector(SEL)) {
        var start = new Date().getTime();
        var iv = setInterval(function () {
          var el = document.querySelector(SEL), gone = !el;
          if (el) {
            var cs = getComputedStyle(el);
            gone = (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.1);
          }
          if (gone || (new Date().getTime() - start) > 6000) { reveal(); clearInterval(iv); }
        }, 200);
      } else if (document.readyState === 'complete') {
        setTimeout(reveal, 700);
      } else {
        window.addEventListener('load', function () { setTimeout(reveal, 700); });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();
})();
